<template>
    <div class="pageWarp appDetail">
        <!-- 标题 -->
        <Title-Box :top-title="topTitle" backgroundColor="transparent"></Title-Box>


        <div class="content_box display_flex jus-c">

            <!-- module切换-右边模块类型 -->
            <ul class="right_menu boxs flex_v">
                <li v-for="(item, index) in moduleType.textArr"
                    :key="index"
                    @click="moduleLi(item, index)"
                    :class="{is_active: moduleType.nowIndex==index}"
                    class="flex_h_hC_vC"
                >
                    {{item.name}}
                </li>       
            </ul>

            <!-- 中间表单 -->
            <div class="g_form_box">

                <div class="titleLine flex-row ite-c">
                    <span>基础信息</span>
                </div>
                <div class="border_box">
                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            应用名称
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{baseInfo.APP_NAME}}
                        </span>
                        
                        <span class="flex_h_hC_vC row_title">
                            客户端
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            <el-tag type="info" size="small">
                                <template>
                                    {{baseInfo.CLIENT | clientFilter}}
                                </template>
                            </el-tag>
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            最新版本
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{baseInfo.VERSION}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            包名
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{baseInfo.PACKAGE_NAME}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            创建时间
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{baseInfo.CREATE_TIME}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            过期日期
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{baseInfo.OVERDUE}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            最新版本下载地址
                        </span>
                        <span class="flex_h_hC_vC row_value" style="width:calc( 100% - 144px )">
                            <b  
                                style="cursor:pointer;font-weight:normal;"
                                class="clamp_1"
                                onmouseover="this.style.cssText='color:#FA6241;cursor:pointer;font-weight:normal'"
                                onmouseout="this.style.cssText='color:#333333;cursor:pointer;font-weight:normal'"
                                @click="openUrl(baseInfo.UPDATE_LATEST_URL)"
                            >
                                {{baseInfo.UPDATE_LATEST_URL}}
                            </b>
                        </span>
                    </div>
                </div>
                


                <div class="titleLine flex-row ite-c">
                    <span>版本信息</span>
                </div>
                <div class="table_box boxs">
                    <el-table :data="versionTableData"
                                style="width: 100%;font-size: 12px"
                                class="tableTheadGray3"
                                border
                                fit
                                tooltip-effect="dark"w
                    >
                        <el-table-column label="版本" prop="VERSION" min-width="100" header-align="center" align="center"
                                         ></el-table-column>
                        <el-table-column label="应用市场" prop="MARKET_ID" width="80" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.MARKET_ID == '2'">
                                    蒲公英
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="更新类型" prop="UPDATE_TYPE" width="80" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>
                                    {{scope.row.UPDATE_TYPE | updateTypeFilter}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="更新次数" prop="UPDATE_TIMES" width="110" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="最后更新日期" prop="UPDATE_TIME" width="140" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="更新描述" prop="UPDATE_CONTENT" min-width="160" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" fixed="right" width="80" header-align="center" align="center"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-button @click="showDeleteDialog(scope)" class="orangeT"
                                            type="text" title="删除"
                                >删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pageBox boxs">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                        :current-page="searchForm.current" :page-sizes="[6, 10, 20, 30]" :page-size="searchForm.size"
                                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </div>
                <!-- <div class="table_box boxs">
                    <el-table :data="versionTableData"
                                style="width: 100%;font-size: 12px"
                                class="tableTheadGray3"
                                border
                                fit
                                tooltip-effect="dark"w
                    >
                        <el-table-column label="版本" prop="VERSION" min-width="130" header-align="center" align="center"
                                         ></el-table-column>
                        <el-table-column label="应用市场" prop="MARKET_ID" width="110" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="更新类型" prop="UPDATE_TYPE" width="110" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="更新次数" prop="update_times" width="110" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="最后更新日期" prop="UPDATE_TIME" min-width="160" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" fixed="right" width="150" header-align="center" align="center"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-button @click="showUpdateDescription(scope)" class="greenT"
                                            type="text" title="更新描述"
                                >更新描述
                                </el-button>
                                <el-button @click="showDeleteDialog(scope)" class="orangeT"
                                            type="text" title="删除"
                                >删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pageBox boxs">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                        :current-page="searchForm.current" :page-sizes="[6, 10, 20, 30]" :page-size="searchForm.size"
                                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </div> -->


                <div class="flex-row jus-c" style="margin: 24px 0 31px;">
                    <button @click="goBack()" class="butStyle close_btn">关 闭</button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import TitleBox from '@/components/Common/TitleBox/TitleBox.1';

    import {
        // 查询版本信息
        getAppVersionListAPI,
        // 删除版本
        deleteVersionAPI,
    } from '@/api/System/appManage.js'
    

    // 搜索表格的条件-筛选栏
    const defaultSearchForm = {
        current: 1, //当前页码
        // size: 10, //每页条数
        size: 6, //每页条数
        params: {
            appId: '',
        }
    }


    export default {
        components: {
            TitleBox
        },
        filters: {
            // 状态过滤器
            statusFilter (status) {
                const statusMap = {
                    '0': '无效',
                    '1': '有效',
                }
                return statusMap[status]
            },
            // 客户端过滤器
            clientFilter (client) {
                const clientMap = {
                    '1': 'ANDROID',
                    '2': 'IOS'
                }
                return clientMap[client]
            },
            // 客户端过滤器
            updateTypeFilter (updateType) {
                const updateTypeMap = {
                    '1': '强制更新',
                    '2': '自选更新'
                }
                return updateTypeMap[updateType]
            }
        },
        data() {
            return {
                //标题
                topTitle: {
                    title: '应用管理',
                    subTit: '详情'
                },
                // 右边模块类型
                moduleType: {
                    textArr: [
                        {name: '基础信息', value: 0},
                        {name: '版本信息', value: 1},
                    ],
                    nowIndex: 0
                },

                
                // 基础信息
                baseInfo: {
                    ID: '', //应用id
                    APP_NAME: '', //应用名称
                    STATUS: '', //状态：0-无效,1-有效
                    CLIENT: '', //客户端：1-ANDROID Q，2-IOS
                    PACKAGE_NAME: '', //包名
                    CREATE_TIME: '', //创建时间
                    OVERDUE: '', //过期日期(当前日期加五年)
                    VERSION: '', //当前最新版本
                    UPDATE_LATEST_URL: '', //最新版本下载地址
                },


                // 版本信息
                versionTableData:[],
                // 表格数据总数
                total: 0,
                // 表格搜索条件
                searchForm: Object.assign({}, defaultSearchForm),
            }
        },
        created() {
            this.initRouterParam();
        },
        methods: {
            // 获取路由携带参数
            initRouterParam() {
                this.baseInfo = this.$route.query;
                // console.log('this.baseInfo:', this.baseInfo)
                this.searchForm.params.appId = this.$route.query.ID;
                this.getVersionData();
            },
            // 切换模块类型
            moduleLi(item, index) {
                this.moduleType.nowIndex = index;
                this.scrollIntoView(index);
            },
            // 把对应的模块内容滚动到可视区域
            scrollIntoView(index){
                document.querySelectorAll(".titleLine")[index].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            },
            // 关闭按钮-返回上一页
            goBack(){
                this.$router.go(-1);
            },
            // 在新窗口打开网址
            openUrl(url){
                window.open(url, '_blank')
            },


            
            // 获取版本信息
            async getVersionData() {
                try {
                    const result = await getAppVersionListAPI(this.searchForm);
                    // console.log(result);
                    this.versionTableData= result.data.records;
                    this.total = result.data.total;
                } catch (e) {
                    this.$message.error('接口请求失败:' + e.msg);
                }
            },


            // 列表每页条数变了
            handleSizeChange(val) {
                this.searchForm.size = val
                this.getVersionData()
            },
            // 列表当前页码变了
            handleCurrentChange(val) {
                this.searchForm.current = val
                this.getVersionData()
            },

            // 弹出框“更新描述” 
            showUpdateDescription(data) {
                const rowData = JSON.parse(JSON.stringify(data.row))

                var $this = this;
                this.$alert(rowData.UPDATE_CONTENT, '更新描述', {
                    confirmButtonText: '确定',
                    // center: true,
                    callback: action => {
                    }
                })
            },
            // 弹出“删除”确认框
            showDeleteDialog(data) {

                const rowData = JSON.parse(JSON.stringify(data.row))

                var delParams = {
                    appId: rowData.APP_ID,
                    id: rowData.ID
                }

                var $this = this;
                this.$confirm('确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    $this.deleteVersion(delParams);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除操作'
                    })
                })
            },
            async deleteVersion(params) {
                try {
                  await deleteVersionAPI(params.id)
                  this.$message.success('删除成功')
                  this.getVersionData()
                } catch (e) {
                  console.log(e)
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .pageWarp {
        height: calc(100vh - 88px);
    }

    .greenT  {
        color: #2DBAA5 !important;
        // font-size: 12px;
    }
    .lightGT {
        color: #76C819 !important;
    }
    .orangeT {
        color: #FA6241 !important;
        // font-size: 12px;
    }
    .grayT {
        color: #B7B2AF !important;
    }
    .blodT {
        font-weight: bold;
    }
    .px18T {
        font-size: 18px;
    }

    .exportBtn {
        position: absolute;
        top: -38px;
        right: 5px;

        width: 72px;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        border-radius: 4px;
        &:hover {
            background-color: rgb(247, 143, 120);
        }
    }

    .exportBtn .exportIcon {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
        background-size: 14px 14px;
    }


    // 右边模块目录
    .right_menu {
        position: fixed;
        top: 118px;
        right: 20px;

        width: 144px;
        padding: 12px 12px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 7px;
        box-shadow: 0px 12px 24px rgba(0,0,0,0.05);

        z-index: 22;
    }
    .right_menu li {
        width: 120px;
        height: 32px;
        border-radius: 7px;
        background: #ffffff;
        color: #333333;
        font-size: 12px;
    }
    .right_menu li+li {
        margin-top: 1px;
    }
    .right_menu li.is_active,
    .right_menu li:hover {
        color: #ffffff;
        background: #FA6241;
    }


    .content_box {
        width: 100%;
        // min-width: calc( 144px + 144px + 900px );
        // min-width: 900px;
        min-width: calc( 144px + 900px );
        padding-right: 144px;
        box-sizing: border-box;
        margin-top: 2px;
        position: relative;
    }

    .g_form_box {
        width: 899px;
        // width: auto;
    }

    // 模块标题
    .g_form_box .titleLine {
        width: 100%;
        height: 16px;
        margin-top: 13px;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    .g_form_box .titleLine span {
        line-height: 16px;
        font-size: 12px;
        font-weight: bold;
        color: #2B2727;
    }

    .g_form_box .titleLine span::before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 16px;
        margin-right: 6px;
        background: #FA6241;
        vertical-align: middle;
    }
    


    // 模块
    .g_form_box .border_box {
        width: 899px;
        margin-top: 13px;
        background: #EEEEEE;
        border: 1px solid #EEEEEE;
    }

    .g_form_box .form_row {
        width: auto;
        // min-width: 449px;
        height: 36px;
        min-height: 36px;
        // line-height: 36px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .g_form_box .form_row+.form_row {
        margin-top: 1px;
    }
    // .g_form_box .form_row.no_border {
    //     border-bottom: none;
    // }

    .g_form_box .form_row span+span {
        margin-left: 1px;
    }

    .g_form_box .form_row .row_title {
        width: 144px;
        height: 100%;
        background: #F5F5F5;
        color: #7F7F7F;
        font-size: 12px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // text-align: center;
    }

    .g_form_box .form_row .row_value {
        width: 304px;
        height: 100%;
        background: #FFFFFF;
        color: #333333;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }



    // 模块提示
    .g_form_box .tip_line {
        width: 100%;
        line-height: 16px;
        color: #7F7F7F;
        font-size: 12px;
        margin-top: 12px;
    }


    // 表格
    .g_form_box .table_box {
        width: 100%;
        margin-top: 12px;
        background: #ffffff;
        padding: 21px 21px;
        box-sizing: border-box;
    }

    .g_form_box .el-table {
        // font-size: 13px !important;
        font-size: 12px !important;
    }
    
    // 分页条
    .g_form_box .pageBox {
        width: 100%;
        padding: 10px 0 10px;
        display: flex;
        justify-content: flex-end;
        background: #ffffff;
        border: 1px solid #ebeef5;
        border-top: none;
    }
    


    // Tabs 标签页(标签页表格)
    .g_form_box .tabs_table_box {
        width: 100%;
        margin-top: 12px;
        background: #ffffff;
        padding: 10px 21px 21px;
        box-sizing: border-box;
    }

    /*表格切换*/
    // .tabs_table_box .tabType {
    //     background: #fff;
    //     height: 40px;
    //     line-height: 40px;
    //     text-align: center;
    //     border-bottom: 1px solid #EEEEEE;
    // }

    // .tabType li {
    //     float: left;
    //     width: 80px;
    //     color: #7F7F7F;
    //     font-size: 12px;
    //     cursor: pointer;
    //     position: relative;
    // }
    // .tabType li:after {
    //     content: '';
    //     position: absolute;
    //     width: 80px;
    //     height: 4px;
    //     background: transparent;
    //     bottom: -4px;
    //     left: 0;
    // }

    // .tabType li.on {
    //     color: #FA6241;
    // }
    // .tabType li.on:after {
    //     background: #FA6241;
    // }

    // .tabs_table_box .table_bottom {
    //     // height: 24px;
    //     // height: 16px;
    //     font-size: 12px;
    //     font-weight:400;
    //     line-height: 16px;
    //     // line-height: 24px;
    //     color: #2B2727;
    //     margin-top: 20px;
    //     background: #fff;
    //     // background: rgb(199, 148, 148);
    // }
    // .tabs_table_box .table_bottom span {
    //     height: 100%;
    // }
    // .tabs_table_box .table_bottom span.px18T {
    //     height: 100%;
    //     line-height: 18px;
    // }



    // 关闭按钮
    .close_btn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        border-radius: 4px;
        background: #FFFFFF;
        color: #2B2727;
        color: #666666;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        &:hover {
            // background-color: #f1f1f1;
            border: 1px solid #d1d0d0;
        }
    }
</style>

